import ProsperoPostType, { ProsperoPostTypeStrings } from 'enums/ProsperoPostType'

export const removeMetaData = (
  displayText: string,
  originalAuthor: string,
  postType: ProsperoPostTypeStrings
) => {
  if (postType === ProsperoPostType.TW_RETWEETS) {
    const header = `RT @${originalAuthor}: `
    if (displayText.indexOf(header) === 0) {
      return displayText.substring(header.length)
    }
  }

  return displayText
}

export default removeMetaData
